// ---------------------------------------------------------------------------
// Table schema types (evaluator-native, decoupled from DB)
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// `missing` — the empty/absent value
// ---------------------------------------------------------------------------
//
// Produced when a referenced cell is empty. Aggregates skip it; every other
// operation (arithmetic, property access, non-aggregate functions) propagates
// it. A formula that reduces to `missing` yields a blank cell with NO error.
// It has no `message` field, so `isError` never misclassifies it as an error.
export const MISSING_VALUE = { type: "missing", value: null };
export function isMissing(value) {
    return value.type === "missing";
}
export class ScalarType {
    name = "scalar";
    validate(value) {
        return typeof value === "number" && isFinite(value);
    }
    convert(value) {
        const num = Number(value);
        if (isNaN(num) || !isFinite(num)) {
            throw new Error(`Cannot convert "${value}" to scalar`);
        }
        return num;
    }
}
export class ArrayType {
    name = "array";
    validate(value) {
        return Array.isArray(value);
    }
    convert(value) {
        if (Array.isArray(value))
            return value;
        return [value];
    }
}
export class ObjectType {
    name = "object";
    validate(value) {
        return typeof value === "object" && value !== null && !Array.isArray(value);
    }
    convert(value) {
        if (this.validate(value))
            return value;
        throw new Error(`Cannot convert "${value}" to object`);
    }
}
export class TableType {
    name = "table";
    validate(value) {
        return (value &&
            typeof value === "object" &&
            "schema" in value &&
            "rows" in value &&
            Array.isArray(value.rows));
    }
    convert(value) {
        if (this.validate(value))
            return value;
        throw new Error(`Cannot convert "${value}" to table`);
    }
}
export class TypeRegistry {
    types = new Map();
    constructor() {
        this.register(new ScalarType());
        this.register(new ArrayType());
        this.register(new ObjectType());
        this.register(new TableType());
    }
    register(type) {
        this.types.set(type.name, type);
    }
    get(typeName) {
        return this.types.get(typeName);
    }
    isValid(value) {
        const typeDef = this.get(value.type);
        if (!typeDef)
            return false;
        return typeDef.validate(value.value);
    }
    convert(value, targetType) {
        const typeDef = this.get(targetType);
        if (!typeDef) {
            throw new Error(`Unknown type: ${targetType}`);
        }
        const convertedValue = typeDef.convert ? typeDef.convert(value) : value;
        return { type: targetType, value: convertedValue };
    }
    getRegisteredTypes() {
        return Array.from(this.types.keys());
    }
}
export const globalTypeRegistry = new TypeRegistry();
//# sourceMappingURL=type-registry.js.map